/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".svi-layout[_ngcontent-%COMP%]{margin:0 auto;max-width:1024px}.content[_ngcontent-%COMP%]{max-width:780px;margin:0 auto;padding:0}"];
export { styles as styles };
